interface CSSColors {
    error: string;
    primary: string;
    secondary: string;
    tertiary: string;
    accent: string;
    background: string;
  }
  
  const CSSColors: CSSColors = {
    error: "error-color",
    primary: "primary-color",
    secondary: "secondary-color",
    tertiary: "tertiary-color",
    accent: "accent-color",
    background: "bgd-color",
  };
  
  export default CSSColors;
  